<script>
import { mapGetters } from 'vuex';
import ReportSearchBlock from '../ReportSearchBlock';

export default {
  name: 'ReportCustomObjects',
  mixins: [ReportSearchBlock],
  data() {
    return {
      placeholder: 'Custom Record Type',
    };
  },
  computed: {
    ...mapGetters('customObjects', ['all']),
    getOptions() {
      return this.all.map((co) => {
        return {
          label: co.label_plural,
          value: co.id,
        };
      });
    },
  },
};
</script>
